import React, { useState, useEffect } from "react";
import { Redirect } from "react-router-dom"
import axios from "axios";
import {LoyaltyTwoTone } from "@material-ui/icons";
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import { format } from "date-fns";
import DateFnsUtils from "@date-io/date-fns";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Typography from "@material-ui/core/Typography";
import FormLabel from '@material-ui/core/FormLabel';
import MUIDataTable from "mui-datatables";
import { NavLink } from "react-router-dom";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import MessageBox from "../../components/MessageBox/MessageBox";
import Paper from '@material-ui/core/Paper';
import NumberFormat from 'react-number-format';
import { findIndex } from "lodash/array";
import {get_cookies, isLoggedIn} from "../../components/Cookies/Cookies";
import Input from '@material-ui/core/Input';
import LoadingOverlay from 'react-loading-overlay';
import numeral from "numeral";
const useStyles = makeStyles((theme) => ({
	title: {
		marginTop: 0,
	},
	field: {
		width: "100%",
		marginBottom: "1rem",
	},
	autoComplete: {
		width: "100%",
		marginTop: "0",
		marginBottom: "0.5rem",
	},
	date: {
		width: "100%",
		marginBottom: "1rem",
	},
	buttonContainer: {
		textAlign: "right",
	},
	modal: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		width: "100%",
		maxWidth: "600px",
		margin: "0 auto",
	},
	paper: {
        backgroundColor: theme.palette.background.paper,

		border: "2px solid #000",
		boxShadow: theme.shadows[5],
		padding: theme.spacing(2, 4, 3),
		width: "800px",
	},
	button: {
		textAlign: "right",
		marginTop: "30px",
		"& .MuiButton-containedPrimary": {
			marginRight: "10px",
		},
	},

	buttonMarginRight: {
		marginRight: "0.5rem",
    },
    paperppp: {
        background: "#339933",
        width:"100%",
        height:"50px",
    },
    formlabelpayment: {
        color:"white",
        margin:"10px",
        float:"right"
    }
}));

const FranchiseItemPrice = (props) => {
	
	const classes = useStyles();
	const navid = props.location.pageInfo ? props.location.pageInfo.navid : '';
    const CurrentPage = props.location.pageInfo ? props.location.pageInfo.navname : '';
    const TransactionInformation = props.location.transactionInfo ? props.location.transactionInfo : '';
    const PackageSalesInformation = props.location.packageInfo ? props.location.packageInfo : '';
    const selectedpackagesInfo = props.location.selectedpackagesInfo
    ? props.location.selectedpackagesInfo
    : props.location.packagechosen;

	//ApiData Component useState SOF
    //Loading overlay
    const [showOverlay, setShowOverlay] = useState(false);
    const [overLayMsg, setOverlayMsg] = useState(false);
    //Loading overlay EOF
	const [items_list, loadItemsDropdown] = useState([]);
    const [branchIdNo, setBranchIdNo] = useState(get_cookies('branchidno'));
    const [branchCurcode, setBranchCurcode] = useState(get_cookies('curcode'));
    const [pointsDetails, setPointsDetails] = useState({});
    const [gen_activationinfo, setGenActivationinfo] = useState({});
    const [navcode, setNavCode] = useState("");
    const [notesinfo, setNotesInfo] = useState("");
    const headers = {
        'Content-Type': 'multipart/form-data',
    };
    const get_max_ppp = () => {
		const form_data = {
			navid: navid,
            curcode:branchCurcode
		}
        const formData = new FormData();
        formData.append('form_data', JSON.stringify(form_data));
		const apiUrl = process.env.REACT_APP_API_URL+'get_max_product';
		axios.post(apiUrl, formData, {headers:headers}).then((res) => {
            if(res.data.success == 1){

            }else{
                setShowMsgBox(true);
                setMsg("Missing navigation ID");
                setMsgType("warning");
                setTimeout(() => {
                    setShowMsgBox(false);
                }, 3000)
            }
		});
    };
    
    const gen_activations_franchise = () => {
		const form_data = {
            navid: navid,
            soldto:TransactionInformation.soldto,
            referencecode: TransactionInformation.refcode,
            curcode:branchCurcode
		}
        const formData = new FormData();
        formData.append('form_data', JSON.stringify(form_data));
		const apiUrl = process.env.REACT_APP_API_URL+'gen_activations_franchise';
		axios.post(apiUrl, formData, {headers:headers}).then((res) => {
            if(res.data.success == 1){
                const newData = {...gen_activationinfo};
                newData['gen_id_arr']= res.data.gen_id.toString();
                newData['gen_pin_arr']= res.data.gen_pin.toString();
                newData['gen_act_arr']= res.data.gen_act.toString();
                newData['nav_code']= res.data.nav_code.toUpperCase();
                setGenActivationinfo({ ...newData });
                setNotesInfo(res.data.nav_code.toUpperCase() + " Product for \n" + TransactionInformation.soldto + "\n Idnos: " + TransactionInformation.activationcode + "," + res.data.gen_id.toString())
                setShowOverlay(false);
                setOverlayMsg('');
            }else{
                setShowOverlay(false);
                setOverlayMsg('');
                setShowMsgBox(true);
                setMsg("Missing navigation ID");
                setMsgType("warning");
                setTimeout(() => {
                    setShowMsgBox(false);
                }, 3000)
            }
		});
    };

    const get_items = () => {
        const formData = new FormData();
        formData.append('form_data', "");
		const apiUrl = process.env.REACT_APP_API_URL+'get_items_franchise';
		axios.post(apiUrl, formData, {headers:headers}).then((res) => {
			loadItemsDropdown(res.data.items);
            setShowOverlay(false);
		});
	};
	//ApiData Component useState EOF
	
	//Message Box
	const [showMsgBox, setShowMsgBox] = useState(false);
	const [msgBoxContent, setMsg] = useState("Empty");
	const [msgType, setMsgType] = useState("success");
	//Message Box EOF

	//Table Settings
	const [TABLE_DATA, setSelectedItemTable] = useState([]);
    const [selectedItem, setSelectedItem] = useState({});
    const [currentSelectedPPP, setCurrentSelectedPPP] = useState(0);
    const [computedPPP, setComputedPPP] = useState({});
    const [excessPrice, setExcessPrice] = useState(0);
     
    const computePPP = () => {  
        let total_ppp = 0;
        for (let index = 0; index < TABLE_DATA.length; index++) {
		    total_ppp = parseFloat(total_ppp) + parseFloat(TABLE_DATA[index].ppp);
        }
        const newData = {...computedPPP};
        newData['total_ppp']= total_ppp.toFixed(2);
        setComputedPPP({ ...newData });
    }

    const validatePPP = () => {  
        computePPP();
        if(computedPPP.total_ppp != "" || computedPPP.total_ppp > 0 || pointsDetails.max_product_price != 0){
            if(computedPPP.total_ppp < pointsDetails.minus3percent){
                setShowMsgBox(true);
                setMsg("Insufficient Product Package Price");
                setMsgType("warning");
                setTimeout(() => {
                    setShowMsgBox(false);
                }, 3000);
            }else{
                if(computedPPP.total_ppp >= pointsDetails.minus3percent || computedPPP.total_ppp >= pointsDetails.max_product_price || computedPPP.total_ppp <= pointsDetails.plus3percent){
                    if(computedPPP.total_ppp > pointsDetails.max_product_price){
                        let excess = parseFloat(computedPPP.total_ppp) - parseFloat(pointsDetails.max_product_price);
                        setExcessPrice(excess);
                    }
                    props.history.push(nextpage);
                }else{
                    setShowMsgBox(true);
                    setMsg("Insufficient Product Package Price");
                    setMsgType("warning");
                    setTimeout(() => {
                        setShowMsgBox(false);
                    }, 3000);
                } 
            }
        }else if(pointsDetails.max_product_price > 0) {
            setShowMsgBox(true);
            setMsg("Please insert item");
            setMsgType("warning");
            setTimeout(() => {
                setShowMsgBox(false);
            }, 3000);
            // props.history.push(nextpage);
        }else{
            props.history.push(nextpage);
        }
    }
    //Callback function if have excess
    useEffect(() => {
        if(computedPPP.total_ppp >= pointsDetails.minus3percent || computedPPP.total_ppp >= pointsDetails.max_product_price || computedPPP.total_ppp <= pointsDetails.plus3percent){
            props.history.push(nextpage);
        }
    }, [excessPrice]);

	const onSelectItem = () => {
        computePPP()
        let newData = [...TABLE_DATA];
        const neededKeys = ["id", "itemname", "ppp", "unit", "qty"];
        if(neededKeys.every(key => Object.keys(selectedItem).includes(key))){
            const tempObj = 
            {
                id:selectedItem.id, 
                itemname:selectedItem.itemname, 
                ppp:selectedItem.ppp.toFixed(2),
                unit:selectedItem.unit,
                qty:selectedItem.qty
            }
            if(selectedItem.id == null || selectedItem.id == "" || selectedItem.ppp == ""){
                setShowMsgBox(true);
                setMsg("Please complete all required fields");
                setMsgType("warning");
                setTimeout(() => {
                    setShowMsgBox(false);
                }, 3000);
            }else{
                if(selectedItem.qty == "" || selectedItem.qty <= 0 || selectedItem.qty == null){
                    setShowMsgBox(true);
                    setMsg("Please insert atleast 1 item");
                    setMsgType("warning");
                    setTimeout(() => {
                        setShowMsgBox(false);
                    }, 3000);
                }else{
                    let amttoadd = parseFloat(computedPPP.total_ppp) + parseFloat(selectedItem.ppp);
                    //maximum value reached
                    if(parseFloat(amttoadd) <= parseFloat(pointsDetails.plus3percent)){
                        addOrUpdate(newData, tempObj);
                    }else{
                        setShowMsgBox(true);
                        setMsg("Maximun product package price reached");
                        setMsgType("warning");
                        setTimeout(() => {
                            setShowMsgBox(false);
                        }, 3000);
                    }
                }
            }
        }else{
            setShowMsgBox(true);
            setMsg("Please select atleast 1 item");
            setMsgType("warning");
            setTimeout(() => {
                setShowMsgBox(false);
            }, 3000);
        }
        handleClose();
	};

    const addOrUpdate = (array, item) => {
        const i = array.findIndex(_item => _item.id === item.id);
        if (i > -1) {
            let ppp = parseFloat(array[i].ppp) + parseFloat(item.ppp);
            let qty = parseFloat(array[i].qty) + parseFloat(item.qty);
            array[i].ppp = ppp.toFixed(2);
            array[i].qty = qty.toFixed(2);
            computePPP();
        }else{
            array.push(item); setSelectedItemTable([...array]);
        }
        setSelectedItem({});
    }

    //Callback function of onSelectItem
    useEffect(() => {
        computePPP();
    }, [TABLE_DATA]);
	const onItemSelectionChange = (event) => {
        const newData = {...selectedItem};
        newData[event.target.name]= event.target.value;
        newData['ppp']= parseFloat(currentSelectedPPP) * parseFloat(event.target.value);
        setSelectedItem({ ...newData });
	};

	const refreshTable = () => {
		const newData = [...TABLE_DATA];
		setSelectedItemTable([...newData]);
	}

	const TABLE_COLUMNS = [
		{
		  name: 'id',
		  label: 'ID',
		}, {
		  name: 'itemname',
		  label: 'Item Name',
		}, {
            name: 'ppp',
            label: 'Price',
        }, {
            name: 'unit',
            label: 'Unit',
        }, {
            name: 'qty',
            label: 'Qty',
        }
	];
	
	const TABLE_OPTION = {
		filterType: 'checkbox',
		selectableRows: 'single',
		selectableRowsHideCheckboxes: true,
		selectableRowsOnClick: true,
        print:false,
		filter:false,
		download: false,
		viewColumns:false,
		onRowsDelete: (data) => { updateSelectedItems(data.data[0].dataIndex) },
	};

	const updateSelectedItems = (index) => {
		TABLE_DATA.splice(index, 1);
		refreshTable();
	}
	//Table Settings EOF

	//Modal Settings
	const [open, setOpen] = useState(false);
	const handleOpen = () => {
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
        setCurrentSelectedPPP("");
        setSelectedItem("");
    };

 	//Modal Settings EOF

	//OnLoad Event/Data Fetching SOF
	useEffect(() => {
        // console.log("props", props);
        isLoggedIn();
        setShowOverlay(true);
        setOverlayMsg('Generating Activations No., Please Wait');

        const newData1 = {...pointsDetails};
        newData1['max_product_price']= props.location.packageInfo.products_price;
        newData1['plus3percent']= parseFloat(props.location.packageInfo.products_price) + parseFloat(props.location.packageInfo.products_price) * 0.03;
        newData1['minus3percent']= parseFloat(props.location.packageInfo.products_price) - parseFloat(props.location.packageInfo.products_price) * 0.03;
        setPointsDetails({ ...newData1 });
        get_items();
        // gen_activations_franchise();
        const newData = {...computedPPP};
        newData['total_ppp'] = 0;
        setComputedPPP({ ...newData });
    }, []);
    //OnLoad Event/Data Fetching SOF

	const dropDownItems = {
		options: items_list,
		getOptionLabel: (option) => option.name  + ' - Php' + option.price,
    };
    
	//FormData
	const [prep_data, setData] = useState({});
	//FormData EOF
	const nextpage =  {
		pathname: "/franchise-payment",
		transactionInfo: TransactionInformation, // your data array of objects
        packageInfo:PackageSalesInformation,
        selectedItemsInfo:TABLE_DATA,
        selectedpackagesInfo,
        notesInfo: notesinfo,
		pageInfo: {
			// navid: navid,
			navname: CurrentPage
        },
        excessPriceInfo: excessPrice,
        // generatedActivationcardsInfo: gen_activationinfo
	}

    const NumberKeyTrapper = (e) => {
        var a = [];
        var k = e.which;
        
        for (let i = 48; i < 58; i++){
            a.push(i);
        }    
        
        if (!(a.indexOf(k)>=0)){
            e.preventDefault();
        }
    }
	return (

		<div className="page">
            <LoadingOverlay
            active={showOverlay}
            spinner
            text={overLayMsg}
            >
			<div className="page-header">
				<div className="page-icon">
					<ShoppingCartIcon />
				</div>
				<Breadcrumbs aria-label="breadcrumb">
					<NavLink to="/franchise-set">
						<h2 className="header-title">Franchise Set</h2>
					</NavLink>
                    <NavLink to="/">
						<h2 className="header-title">{props.location.packageInfo.packagetype} - {props.location.packageInfo.packagetypename}</h2>
					</NavLink>
                    <NavLink to="/Franchise-information">
						<h2 className="header-title">{props.location.packageInfo.packagetype} - {props.location.packageInfo.packagetypename}</h2>
					</NavLink>
					<Typography color="textPrimary">{"Franchise Item "}</Typography>
				</Breadcrumbs>
			</div>
			<div className="page-container">
                <form noValidate autoComplete="off">
					<MessageBox in={showMsgBox} content={msgBoxContent} type={msgType}/>
                <Grid container spacing={2} className={classes.root}>
                    {/* <Grid item xs={12}>
                        <Card>
                            <CardContent>
                                <h4 className={classes.title}>Transaction Information</h4>
                                <Grid container>
                                    <Grid item xs={12} sm={6}>
                                        <Grid container>
                                            <Grid xs={12} sm={3}>
                                                <FormLabel>Activation Code:</FormLabel>
                                            </Grid>
                                            <Grid xs={12} sm={9}>
                                                <FormLabel>{TransactionInformation.activationcode}</FormLabel>
                                            </Grid>
                                        </Grid>
                                        <Grid container>
                                            <Grid xs={12} sm={3}>
                                                <FormLabel>Ref Code:</FormLabel>
                                            </Grid>
                                            <Grid xs={12} sm={9}>
                                                <FormLabel>{TransactionInformation.refcode}</FormLabel>
                                            </Grid>
                                        </Grid>
                                        <Grid container>
                                            <Grid xs={12} sm={3}>
                                                <FormLabel>Location:</FormLabel>
                                            </Grid>
                                            <Grid xs={12} sm={9}>
                                                <FormLabel>{TransactionInformation.warehouse_desc}</FormLabel>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <Grid container>
                                            <Grid xs={12} sm={3}>
                                                <FormLabel>Shipping:</FormLabel>
                                            </Grid>
                                            <Grid xs={12} sm={9}>
                                                <FormLabel>{TransactionInformation.shipping_desc}</FormLabel>
                                            </Grid>
                                        </Grid>
                                        <Grid container>
                                            <Grid xs={12} sm={3}>
                                                <FormLabel>Primary Team:</FormLabel>
                                            </Grid>
                                            <Grid xs={12} sm={9}>
                                                <FormLabel>{TransactionInformation.primaryteam_desc}</FormLabel>
                                            </Grid>
                                        </Grid>
                                        <Grid container>
                                            <Grid xs={12} sm={3}>
                                                <FormLabel>Secondary Team:</FormLabel>
                                            </Grid>
                                            <Grid xs={12} sm={9}>
                                                <FormLabel>{TransactionInformation.secondaryteam_desc}</FormLabel>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>
                    </Grid> */}
                                <Grid item xs={12}>
                                  <Card>
                                    <CardContent>
                                      <Grid container spacing={3}>
                                        <Grid item xs={4}>
                                          <h4 className={classes.title}>Wholesaler Information</h4>
                                          <TextField
                                            label="First Name"
                                            variant="standard"
                                            type="text"
                                            disabled
                                            InputProps={{
                                              style: { color: "#102027" },
                                              disabled: true,
                                            }}
                                            className={classes.field}
                                            defaultValue={TransactionInformation.fname}
                                          />
                                          <TextField
                                            label="Middle Name"
                                            variant="standard"
                                            type="text"
                                            disabled
                                            InputProps={{
                                              style: { color: "#102027" },
                                              disabled: true,
                                            }}
                                            className={classes.field}
                                            defaultValue={TransactionInformation.mname}
                                          />
                    
                                          <TextField
                                            label="Last Name"
                                            variant="standard"
                                            type="text"
                                            disabled
                                            InputProps={{
                                              style: { color: "#102027" },
                                              disabled: true,
                                            }}
                                            className={classes.field}
                                            defaultValue={TransactionInformation.lname}
                                          />
                    
                                          <TextField
                                            label="Date of birth"
                                            variant="standard"
                                            type="text"
                                            disabled
                                            InputProps={{
                                              style: { color: "#102027" },
                                              disabled: true,
                                            }}
                                            className={classes.field}
                                            defaultValue={TransactionInformation.dob}
                                          />
                                          <TextField
                                            label="Email"
                                            variant="standard"
                                            type="text"
                                            disabled
                                            InputProps={{
                                              style: { color: "#102027" },
                                              disabled: true,
                                            }}
                                            className={classes.field}
                                            defaultValue={TransactionInformation.email}
                                          />
                                          <TextField
                                            label="Contact Number"
                                            variant="standard"
                                            type="text"
                                            disabled
                                            InputProps={{
                                              style: { color: "#102027" },
                                              disabled: true,
                                            }}
                                            className={classes.field}
                                            defaultValue={TransactionInformation.conno}
                                          />
                                                                <TextField
                                            label="Sponsor ID No."
                                            variant="standard"
                                            type="text"
                                            disabled
                                            InputProps={{
                                              style: { color: "#102027" },
                                              disabled: true,
                                            }}
                                            className={classes.field}
                                            defaultValue={TransactionInformation.sponsor_id}
                                          />
                                        </Grid>
                                        <Grid item xs={4}>
                                          <h4 className={classes.title}>Transaction Information</h4>
                                          <TextField
                                            label="Transaction Date"
                                            variant="standard"
                                            type="text"
                                            disabled
                                            InputProps={{
                                              style: { color: "#102027" },
                                              disabled: true,
                                            }}
                                            className={classes.field}
                                            defaultValue={TransactionInformation.trandate}
                                          />
                                          <TextField
                                            label="Activation Code"
                                            variant="standard"
                                            type="text"
                                            disabled
                                            InputProps={{
                                              style: { color: "#102027" },
                                              disabled: true,
                                            }}
                                            className={classes.field}
                                            defaultValue={TransactionInformation.activationcode}
                                          />
                    
                                          <TextField
                                            label="Reference Code"
                                            variant="standard"
                                            type="text"
                                            disabled
                                            InputProps={{
                                              style: { color: "#102027" },
                                              disabled: true,
                                            }}
                                            className={classes.field}
                                            defaultValue={TransactionInformation.refcode}
                                          />
                    
                                          <TextField
                                            label="Primary Team"
                                            variant="standard"
                                            type="text"
                                            disabled
                                            InputProps={{
                                              style: { color: "#102027" },
                                              disabled: true,
                                            }}
                                            className={classes.field}
                                            defaultValue={TransactionInformation.primaryteam_desc}
                                          />
                                          <TextField
                                            label="Secondary Team"
                                            variant="standard"
                                            type="text"
                                            disabled
                                            InputProps={{
                                              style: { color: "#102027" },
                                              disabled: true,
                                            }}
                                            className={classes.field}
                                            defaultValue={TransactionInformation.secondaryteam_desc}
                                          />
                                          <TextField
                                            label="Location"
                                            variant="standard"
                                            type="text"
                                            disabled
                                            InputProps={{
                                              style: { color: "#102027" },
                                              disabled: true,
                                            }}
                                            className={classes.field}
                                            defaultValue={TransactionInformation.warehouse_desc}
                                          />
                                          <TextField
                                            label="Shipping Type"
                                            variant="standard"
                                            type="text"
                                            disabled
                                            InputProps={{
                                              style: { color: "#102027" },
                                              disabled: true,
                                            }}
                                            className={classes.field}
                                            defaultValue={TransactionInformation.shipping_desc}
                                          />
                                          <TextField
                                            label="Shipping Charge"
                                            variant="standard"
                                            type="text"
                                            disabled
                                            InputProps={{
                                              style: { color: "#102027" },
                                              disabled: true,
                                            }}
                                            className={classes.field}
                                            defaultValue={TransactionInformation.shippingcharge}
                                          />
                                        </Grid>
                                        <Grid item xs={4}>
                                          <h4 className={classes.title}>
                                            Wholesale Set Information
                                          </h4>
                                          <TextField
                                            label="Account Type"
                                            variant="standard"
                                            type="text"
                                            disabled
                                            InputProps={{
                                              style: { color: "#102027" },
                                              disabled: true,
                                            }}
                                            className={classes.field}
                                            defaultValue={props.location.packageInfo.packagetype}
                                          />
                                          <TextField
                                            label="Acount Type Name"
                                            variant="standard"
                                            type="text"
                                            disabled
                                            InputProps={{
                                              style: { color: "#102027" },
                                              disabled: true,
                                            }}
                                            className={classes.field}
                                            defaultValue={props.location.packageInfo.packagetypename}
                                          />
                    
                    
                    
                                          <TextField
                                            label="Wholesale Set Price"
                                            variant="standard"
                                            type="text"
                                            disabled
                                            InputProps={{
                                              style: { color: "#102027" },
                                              disabled: true,
                                            }}
                                            className={classes.field}
                                            defaultValue={numeral(props.location.packageInfo.franchise_price).format("0,0.00")}
                                          />
                                                                <TextField
                                            label="Maximum Set Count"
                                            variant="standard"
                                            type="text"
                                            disabled
                                            InputProps={{
                                              style: { color: "#102027" },
                                              disabled: true,
                                            }}
                                            className={classes.field}
                                            defaultValue={props.location.packageInfo.wholesale_count}
                                          />
                                        </Grid>
                                      </Grid>
                                    </CardContent>
                                  </Card>
                                </Grid>

                                {pointsDetails.max_product_price == 0 ?null :              <>    <Grid item xs={8}>
						<Grid item xs={12}>
                            <Card>
                                <CardContent>
                                    <h4 className={classes.title}>Product Price Details</h4>
									<Grid container spacing={2}>
										<Grid xs={12} >
											<div className={classes.button}>
												<Button variant="outlined" color="primary" onClick={handleOpen} className={classes.buttonMarginRight}>
													Add Item
												</Button>
											</div>	
										</Grid>
										<Grid item xs={12}>										
											<MUIDataTable
												title={
													<div>
														<div className="table-title">
															Selected Item
														</div>
													</div>
												}
												id="table-grid"
												data={TABLE_DATA}
												columns={TABLE_COLUMNS}
												options={TABLE_OPTION}
											/>
										</Grid> 
									</Grid>
                                </CardContent>
                            </Card>
                        </Grid>
                    </Grid>
                                       <Grid item xs={4}>
                                       <Card>
                                           <CardContent>
                                               <h4 className={classes.title}>Product Package Point Details</h4>
                                               <Grid container spacing={2}>
                                                   <Grid item xs={12}>
                                                       <Paper variant="outlined" className={classes.paperppp}>
                                                           
                                                       <FormLabel className={classes.formlabelpayment}>
                                                           <Grid container justifyContent="flex-end">
                                                               <Grid item xs={12}>
                                                                   Product Price: 
                                                               </Grid>
                                                               <Grid item xs={12}>
                                                                   <NumberFormat value={pointsDetails.max_product_price} displayType={'text'} decimalScale={2} thousandSeparator={true}/>
                                                               </Grid>
                                                           </Grid>
                                                       </FormLabel>
                                                       </Paper>
                                                   </Grid>
                                                   <Grid item xs={12}>
                                                       <Paper variant="outlined" className={classes.paperppp}>
                                                           <FormLabel className={classes.formlabelpayment}>
                                                               Total: 
                                                               <NumberFormat value={computedPPP.total_ppp} displayType={'text'} decimalScale={2} thousandSeparator={true}/>
                                                           </FormLabel>
                                                       </Paper>
                                                   </Grid>
                                               </Grid>
                                           </CardContent>
                                       </Card>
                                   </Grid></>}
  
 
                    <Grid item xs={12}>

						{/* <Grid item xs={12}>
                            <Card>
                                <CardContent>
                                    <p>{gen_activationinfo.nav_code}</p>
                                    <p>{" Product for : " +TransactionInformation.soldto}</p>
                                    <p>{" Idnos : " +TransactionInformation.activationcode}</p>
                                    <p style={{wordBreak:"break-all"}}>{gen_activationinfo.gen_id_arr}</p>
                                </CardContent>
                            </Card>
                        </Grid> */}
                    </Grid>                    
                </Grid> 
                <Grid item xs="12" className={classes.buttonContainer}>
                    <Button 
                        variant="contained" 
                        color="primary"
                        onClick={validatePPP}
                        >
                        Next
                    </Button>
                </Grid>
                <div>
                    <Modal
                        aria-labelledby="transition-modal-title"
                        aria-describedby="transition-modal-description"
                        className={classes.modal}
                        open={open}
                        onClose={handleClose}
                        closeAfterTransition
                        BackdropComponent={Backdrop}
                        BackdropProps={{
                            timeout: 500,
                        }}
                    >
                        <Fade in={open}>
                            <div className={classes.paper}>
                                <h2 id="transition-modal-title">Add Item</h2>
                                <form action="" className={classes.root}>
                                    <Grid container spacing={3}>
                                        <Grid item xs={3}>
                                            Item
                                        </Grid>
                                        <Grid item xs={9}>
                                            <Autocomplete
                                                {...dropDownItems}
                                                autoComplete
                                                includeInputInList
                                                className={classes.autoComplete}
                                                name="itemname"
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        margin="normal"
                                                        label="Packages"	
                                                        variant="outlined"
                                                        required="true"
                                                    />
                                                )}
                                                onChange={(event, newValue) => {
                                                    if (!newValue == "" || !newValue == null){
                                                        const newData = {...selectedItem};
                                                        newData['id']= JSON.stringify(newValue.code, null, ' ');
                                                        newData['itemname']= newValue.name;
                                                        newData['unit']= newValue.unit;
                                                        setCurrentSelectedPPP(newValue.price);
                                                        setSelectedItem({ ...newData });
                                                    }else{
                                                        setCurrentSelectedPPP("");
                                                        setSelectedItem("");
                                                    }
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={3}>
                                            Quantity
                                        </Grid>
                                        <Grid item xs={9}>
                                            <TextField
                                                type="number"
                                                required
                                                name="qty"
                                                label="Quantity"
                                                variant="outlined"
                                                onChange={onItemSelectionChange}
                                                inputProps={{ min: 0, max: 10000 }}
                                                onKeyPress={NumberKeyTrapper}
                                            />
                                        </Grid>
                                    </Grid>
                                    <div className={classes.button}>
                                        <Button
                                            variant="contained"
                                            onClick={handleClose}
                                            className={classes.buttonMarginRight}
                                        >
                                            Close
                                        </Button>
                                        <Button 
                                            variant="contained" 
                                            color="primary"
                                            onClick={onSelectItem}
                                        >
                                            Add
                                        </Button>
                                    </div>
                                </form>
                            </div>
                        </Fade>
                    </Modal>
                </div>
                </form>
            </div>
            </LoadingOverlay>
        </div>
	);
};

export default FranchiseItemPrice;
